// import { ChevronLeft, ChevronRight } from "lucide-react";
// import React from "react";
// import DatePicker from "react-datepicker";
// import calendar from '../assets/calendar.png';
// import downloadingRed from '../assets/downloadingRed.png';

// const CommonTable = ({
//   isPagination = false,
//   paginationClass = "",
//   leftComponent = null,
//   rightComponent = null,
//   columns,
//   data,
//   emptyMessage = "No data Found",
//   total = 0,
//   currentPage = 1,
//   selectedDate = null,
//   setSelectedDate = () => { },
//   setCurrentPage = () => { },
//   itemsPerPage = 10,
//   totalPages = 1,
//   setItemsPerPage = () => { },
//   extraTableClass,
// }) => {
//   return (
//     <>
//       {isPagination && (
//         <div className={`min-w-auto bg-[#FFFFFF] rounded-t-2xl shadow-sm overflow mt-[16px] md:mt-10 flex justify-end gap-4   px-[11.5px] ${paginationClass}`}>
//           {leftComponent && leftComponent}
//           <div className="flex items-center space-x-2">
//             <div className="flex items-center space-x-2">
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
//                 className="text-red-500"
//               >
//                 <ChevronLeft className="h-5 w-5" />
//               </button>
//               <span className="text-sm">
//                 {(currentPage - 1) * itemsPerPage + 1}-
//                 {Math.min(currentPage * itemsPerPage, total)}
//                 <span className="text-gray-500"> of {total || 0}</span>
//               </span>

//               <button
//                 onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
//                 disabled={currentPage === totalPages}
//                 className="text-red-500"
//               >
//                 <ChevronRight className="h-5 w-5" />
//               </button>
//               <div className="flex justify-between items-center px-[20px]">
//                 <div className="flex items-center">
//                   <span>Show</span>
//                   <select
//                     className="  py-1 text-sm"
//                     value={itemsPerPage}
//                     onChange={(e) => {
//                       setItemsPerPage(Number(e.target.value));
//                       setCurrentPage(1);
//                     }}
//                   >
//                     {[10, 20, 30, 50].map((num) => (
//                       <option key={num} value={num}>
//                         {num}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//             </div>
//             {rightComponent && rightComponent}
//             <div className="flex justify-end gap-4 bg-white py-[11.5px] px-[11.5px] rounded-t-2xl">
//               <div className="relative">
//                 <DatePicker
//                   selected={selectedDate}
//                   popperPlacement="bottom-start"
//                   // popperClassName="z-50"
//                   onChange={(date) => setSelectedDate(date)}
//                   customInput={
//                     <button className="!p-2 !bg-[#FFFFFF] border border-[#BEBEBE] !rounded-full transition duration-150 ease-in-out">
//                       <img alt="uploading" src={calendar} className="w-[13px] h-[13px] text-gray-700" />
//                     </button>
//                   }
//                 />
//               </div>
//               <button
//                 // onClick={() => handleDownload()}
//                 className="!p-2 bg-[#FFFFFF] border border-[#BEBEBE] !rounded-full transition duration-150 ease-in-out"
//               >
//                 <img alt="download" src={downloadingRed} className="w-[13px] h-[13px] text-gray-700" />
//               </button>

//             </div>
//           </div>
//         </div>
//       )}
//       <div className={`overflow-x-auto ${extraTableClass}`}>
//         <table className="min-w-full text-sm text-left border-spacing-y-2">
//           <thead className="text-[#000000] bg-[#F7F7F8]">
//             <tr>
//               {columns.map((col, idx) => (
//                 <th
//                   key={idx}
//                   className={`px-4 py-[17.5px] whitespace-nowrap font-medium ${col.className || ""}`}
//                   onClick={col.sortable && col.onSort ? () => col.onSort(col.key) : undefined}
//                 >
//                   <div
//                     className={`flex items-center gap-2 ${idx === columns.length - 1 ? "justify-end" : ""}`}
//                   >
//                     {col.label}
//                     {col.sortable && col.sortIcon && col.sortIcon(col.key)}
//                   </div>
//                 </th>
//               ))}
//             </tr>
//           </thead>


//           <tbody className="bg-[#F5F5F5]">
//             {data.length === 0 ? (
//               <tr>
//                 <td
//                   colSpan={columns.length}
//                   className="text-center font-bold text-red-500 bg-white py-10 h-[200px]"
//                 >
//                   {emptyMessage}
//                 </td>
//               </tr>
//             ) : (
//               data.map((item, idx) => (
//                 <tr
//                   key={idx}
//                   className="bg-white border border-gray-200 mb-2 rounded-md shadow-sm"
//                 >
//                   {columns.map((col, colIndex) => (
//                     <td
//                       key={colIndex}
//                       className={`px-4 py-[22.5px] text-gray-700 whitespace-nowrap align-middle ${col.tdClassName || ""}`}
//                     >
//                       {col.render ? col.render(item, idx) : item[col.key]}
//                     </td>
//                   ))}
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//     </>
//   );
// };

// export default CommonTable;
// import { ChevronLeft, ChevronRight, ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import calendar from '../assets/calendar.png';
import downloadingRed from '../assets/downloadingRed.png';
import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Inbox } from "lucide-react";
import Loading from "./Loading";
import { pageSizeOptions } from "../Utils/pagination";

const CommonTable = ({
  isPagination = false,
  tablename = "",
  paginationClass = "",
  leftComponent = null,
  rightComponent = null,
  columns,
  data,
  emptyMessage = "No data Found",
  total = 0,
  currentPage = 1,
  selectedDate = null,
  setSelectedDate = () => { },
  setCurrentPage = () => { },
  itemsPerPage = 10,
  totalPages = 1,
  setItemsPerPage = () => { },
  extraTableClass,
  onDownload = () => { },
  BottomComponent = null,
  hideDateAndDownload = false,
  hideDownload = false,
  hideDate = false,
  // Opt-in: screens that build their file server-side pass this so the button
  // shows progress for the whole wait. Defaults off, so every other caller is
  // unaffected.
  downloading = false,
  loading = false,
  renderExpanded = null,
}) => {
  const [expandedRows, setExpandedRows] = useState({});

  const toggleRow = (index) => {
    setExpandedRows(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <>
      {isPagination && (
        <div className={`min-w-auto bg-white rounded-t-2xl border border-gray-100 border-b-0 shadow-sm mt-[16px] md:mt-10 flex flex-col lg:flex-row items-center lg:gap-4 gap-2 px-4 py-3 ${paginationClass} ${tablename || leftComponent ? "lg:justify-between" : "lg:justify-end"}`}>
          <div className="flex items-center gap-4">
            {tablename && <div className="flex items-center gap-2 text-base font-semibold text-gray-900"><span className="w-1.5 h-5 rounded-full bg-[#EE3B31]"></span>{tablename}</div>}
            {leftComponent && <div className="flex justify-start">{leftComponent}</div>}
          </div>

          <div className="flex flex-col md:flex-row items-center gap-2 md:gap-3">
            <div className="flex items-center gap-1">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 hover:text-[#EE3B31] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
              >
                <ChevronLeft className="h-4 w-4" />
              </button>
              <span className="text-sm text-gray-600 px-1 whitespace-nowrap">
                <span className="font-semibold text-gray-900">
                  {(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, total)}
                </span>
                <span className="text-gray-400"> of {total || 0}</span>
              </span>
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 hover:text-[#EE3B31] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
              >
                <ChevronRight className="h-4 w-4" />
              </button>

              <div className="flex items-center gap-2 pl-3 ml-2 border-l border-gray-200">
                <span className="text-sm text-gray-500">Show</span>
                <select
                  className="py-1.5 px-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-[#EE3B31]/20 cursor-pointer"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  {pageSizeOptions(total, itemsPerPage).map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {rightComponent && rightComponent}

            {!hideDateAndDownload && (
              <div className="flex justify-end gap-2">
                {!hideDate && (
                  <div className="relative">
                    <DatePicker
                      selected={selectedDate}
                      popperPlacement="bottom-start"
                      onChange={(date) => setSelectedDate(date)}
                      customInput={
                        <button className="!p-2 !bg-white border border-gray-200 !rounded-lg hover:bg-gray-50 transition duration-150 ease-in-out">
                          <img alt="calendar" src={calendar} className="w-[15px] h-[15px]" />
                        </button>
                      }
                    />
                  </div>
                )}
                {!hideDownload && (
                  <button
                    onClick={onDownload}
                    disabled={downloading}
                    title={downloading ? "Preparing your file…" : "Download"}
                    aria-busy={downloading}
                    aria-label={downloading ? "Preparing your file" : "Download"}
                    className="!p-2 bg-white border border-gray-200 !rounded-lg hover:bg-gray-50 transition duration-150 ease-in-out disabled:cursor-not-allowed disabled:hover:bg-white"
                  >
                    {downloading ? (
                      <span className="block w-[15px] h-[15px] rounded-full border-2 border-gray-200 border-t-[#EE3B31] animate-spin" />
                    ) : (
                      <img alt="download" src={downloadingRed} className="w-[15px] h-[15px]" />
                    )}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Desktop Table View */}
      <div className={`hidden lg:block relative ${extraTableClass}`}>
        <Loading loading={loading} overlay="table" />
        <div className="overflow-x-auto bg-white border border-gray-100 border-t-0 rounded-b-2xl shadow-sm">
          <table className="min-w-full text-sm text-left">
            <thead>
              <tr className="bg-[#FAFAFB] border-b border-gray-100">
                {columns.map((col, idx) => (
                  <th
                    key={idx}
                    className={`px-5 py-4 whitespace-nowrap text-xs font-semibold uppercase tracking-wider text-gray-500 ${col.sortable && col.onSort ? "cursor-pointer select-none hover:text-gray-700" : ""} ${col.className || ""}`}
                    onClick={col.sortable && col.onSort ? () => col.onSort(col.key) : undefined}
                  >
                    <div
                      className={`!flex items-center gap-1.5 ${idx === columns.length - 1 ? "justify-end" : ""}`}
                    >
                      {col.label}
                      {col.sortable && col.sortIcon && col.sortIcon(col.key)}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} className="bg-white">
                    <div className="flex flex-col items-center justify-center py-16 text-gray-300">
                      <Inbox className="h-10 w-10" strokeWidth={1.5} />
                      <p className="mt-3 text-sm font-medium text-gray-400">{emptyMessage}</p>
                    </div>
                  </td>
                </tr>
              ) : (
                data.map((item, idx) => {
                  const expandedContent = renderExpanded ? renderExpanded(item, idx) : null;
                  return (
                    <React.Fragment key={idx}>
                      <tr className="border-b border-gray-50 last:border-0 hover:bg-gray-50 transition-colors">
                        {columns.map((col, colIndex) => (
                          <td
                            key={colIndex}
                            className={`px-5 py-4 text-gray-700 whitespace-nowrap align-middle ${col.tdClassName || ""}`}
                          >
                            {col.render ? col.render(item, idx) : item[col.key]}
                          </td>
                        ))}
                      </tr>
                      {expandedContent && (
                        <tr className="bg-gray-50/60">
                          <td colSpan={columns.length} className="p-0 border-b border-gray-100">
                            {expandedContent}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Card View */}
      <div className={`lg:hidden relative ${extraTableClass}`}>
        <Loading loading={loading} overlay={true} />
        {data.length === 0 ? (
          <div className="flex flex-col items-center justify-center bg-white rounded-2xl border border-gray-100 py-16 text-gray-300">
            <Inbox className="h-10 w-10" strokeWidth={1.5} />
            <p className="mt-3 text-sm font-medium text-gray-400">{emptyMessage}</p>
          </div>
        ) : (
          <div className="pb-20">
             {/* Mobile "Header" for Select All */}
             {columns[0]?.key === 'select' && (
              <div className="bg-white border border-gray-200 rounded-lg shadow-sm mb-3 p-4 flex items-center gap-3">
                <div className="shrink-0 mt-0.5">
                  {columns[0].label}
                </div>
                <div className="text-sm font-medium text-gray-700">
                  Select All
                </div>
              </div>
            )}

            {data.map((item, idx) => {
              const isSelectCol = columns[0]?.key === 'select';
              
              // Determine which columns to show in the main (collapsed) view
              const mobileMainCols = columns.filter(col => col.mobileMain);
              const useLegacyMobile = mobileMainCols.length === 0;
              const primaryCols = useLegacyMobile 
                ? [columns[isSelectCol ? 1 : 0]].filter(Boolean)
                : mobileMainCols;

              return (
                <div key={idx} className="bg-white border border-gray-100 rounded-xl shadow-sm mb-3 hover:shadow-md transition-shadow">
                  {/* First Row - Always Visible */}
                  <div className="p-4 flex items-start justify-between gap-3">
                    {/* Checkbox if present */}
                    {isSelectCol && (
                      <div className="shrink-0 mt-0.5">
                        {columns[0].render(item, idx)}
                      </div>
                    )}

                    <div className="flex-1 space-y-2">
                       {primaryCols.map((col, cIdx) => (
                          <div key={cIdx} className="flex items-center justify-between">
                            <span className="text-sm font-normal text-gray-500">
                              {col.label}
                            </span>
                            <span className="text-sm text-gray-700">
                              {col.render ? col.render(item, idx) : item[col.key]}
                            </span>
                          </div>
                       ))}
                    </div>

                    {columns.length > (isSelectCol ? primaryCols.length + 1 : primaryCols.length) && (
                      <button
                        onClick={() => toggleRow(idx)}
                        className="ml-2 p-1 text-gray-500 hover:text-gray-700 shrink-0"
                      >
                        {expandedRows[idx] ? (
                          <ChevronUp className="h-4 w-4" />
                        ) : (
                          <ChevronDown className="h-4 w-4" />
                        )}
                      </button>
                    )}
                  </div>

                  {/* Dropdown Content - Remaining Rows */}
                  {expandedRows[idx] && (
                    <div className="border-t border-gray-200 p-4 space-y-3">
                      {columns.map((col, colIndex) => {
                        // Skip select column and primary columns
                        if ((isSelectCol && colIndex === 0) || primaryCols.includes(col)) return null;

                        return (
                          <div key={colIndex} className="flex items-center justify-between">
                            <span className="text-sm font-medium text-gray-500">
                              {col.label}
                            </span>
                            <span className="text-sm text-gray-700 text-right">
                              {col.render ? col.render(item, idx) : item[col.key]}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* Inline expanded content (e.g. Tag Ref IDs of a batch) */}
                  {renderExpanded && renderExpanded(item, idx) && (
                    <div className="border-t border-gray-200">
                      {renderExpanded(item, idx)}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
      {BottomComponent && <div className="p-0 shrink-0">{BottomComponent}</div>}
    </>
  );
};

export default CommonTable;
